<script lang="ts">
const STICKY_THRESHOLD_TOP = 48
</script>
<script setup lang="ts">
const props = defineProps({
  groupId: null,
  files: null,
  numColumns: null
})
const groupRef = useTemplateRef<HTMLDivElement>("groupRef")
const collapsed = ref(false)
const sticky = ref(false)
const { top, bottom } = useElementBounding(groupRef)

// pixels from the top of the viewport to consider it sticky


watch(top, (top) => {
  if (collapsed.value)
    sticky.value = false

  if (top < STICKY_THRESHOLD_TOP && bottom.value > STICKY_THRESHOLD_TOP)
    sticky.value = true
  else
    sticky.value = false
})
</script>

<template>
  <div ref="groupRef" class="detail-group">
    <div class="detail-group-header">
      <div class="detail-group-header-sticky" :class="{ sticky }">
        <div class="detail-group-header-title">
          {{ props.groupId }}
        </div>
        <div class="detail-group-header-detail">
          <!-- <div>See all</div> -->
          <icon-action type="chevron-down" size="xs" />
        </div>
      </div>
      <div class="detail-group-header-line" />
    </div>
    <div
      class="detail-list"
      :style="{
        gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))`,
      }"
    >
      <collection-detail-file
        v-for="file in files"
        :key="file.id"
        :file-id="file.id"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.detail-group
  @apply flex flex-col

.detail-group-header
  @apply flex items-center gap-0 h-[20px] p-3.5

.detail-group-header-sticky
  @apply flex-none flex items-center -ml-2 pl-2 pr-1 py-0.5
  &.sticky
    @apply fixed top-[48px] z-1 bg-[#{$pill-bg-default}] rounded-[#{$pill-btz-br-default}]
    @apply backdrop-blur-$menu-blur-default backdrop-filter

.detail-group-header-title
  @apply t-collection-xs flex-none pr-1 text-[#{$global-t-secondary}] text-ellipsis-inline

.detail-group-header-detail
  @apply flex flex-none t-menu-xs text-[#{$menu-t-item-shortcut}] px-0.25 py-0.25 rounded-[#{$pill-btz-br-default}] cursor-pointer
  &:hover
    @apply bg-[#{$menu-bg-default}]

.detail-group-header-line
  @apply flex-grow-1 w-full h-0 border-t border-[#{$page-b-group-divider}] ml-1.5

.detail-group-header-chevron
  @apply text-[#{$global-bg-icon-secondary}]

.detail-list
  @apply grid grid-cols-2 gap-0.5 overflow-x-hidden px-2
</style>
